<template>
  <div
    class="logo"
    @click="$emit('click')"
  >
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_118_264)">
				<path d="M0.800049 0.800049H15.7662H31.2M0.800049 0.800049V31.2M0.800049 0.800049L10.24 10.08M31.2 0.800049V31.2M31.2 0.800049L21.6903 9.99799M0.800049 31.2L10.2318 22.08M0.800049 31.2H31.2M10.24 10.08L10.2318 22.08M10.24 10.08L21.6903 9.99799M31.2 31.2L21.7683 22.08M21.6903 9.99799L21.7683 22.08M21.7683 22.08H10.2318" stroke="#64748B"/>
				<path d="M31.2 1.6C31.6419 1.6 32 1.24183 32 0.800008C32 0.358165 31.6419 0 31.2 0C30.7582 0 30.4 0.358181 30.4 0.799992C30.4 1.24183 30.7582 1.6 31.2 1.6Z" fill="#64748B"/>
				<path d="M0.799984 31.9999C1.24182 31.9999 1.6 31.6418 1.6 31.1999C1.59998 30.758 1.24181 30.3999 0.799968 30.3999C0.358179 30.3999 0 30.758 0 31.1999C0 31.6418 0.358179 31.9999 0.799984 31.9999Z" fill="#64748B"/>
				<path d="M21.6 10.9333C22.0419 10.9333 22.4 10.5751 22.4 10.1333C22.4 9.69141 22.0419 9.33325 21.6 9.33325C21.1582 9.33325 20.8 9.69144 20.8 10.1333C20.8 10.5751 21.1582 10.9333 21.6 10.9333Z" fill="#64748B"/>
				<path d="M1.12 1.12012L10.24 10.0801V22.0801H21.76L31.2 31.2001" stroke="#64748B"/>
				<path d="M31.2 31.9999C31.6419 31.9999 32 31.6418 32 31.1999C32 30.758 31.6419 30.3999 31.2 30.3999C30.7582 30.3999 30.4 30.758 30.4 31.1999C30.4 31.6418 30.7582 31.9999 31.2 31.9999Z" fill="#64748B"/>
				<path d="M10.1333 22.9333C10.5752 22.9333 10.9334 22.5751 10.9334 22.1333C10.9333 21.6914 10.5752 21.3333 10.1333 21.3333C9.69156 21.3333 9.33337 21.6914 9.33337 22.1333C9.33337 22.5751 9.69156 22.9333 10.1333 22.9333Z" fill="#64748B"/>
				<path d="M21.7599 22.88C22.2018 22.88 22.56 22.5219 22.56 22.08C22.5599 21.6382 22.2018 21.28 21.7599 21.28C21.3181 21.28 20.96 21.6382 20.96 22.08C20.96 22.5219 21.3181 22.88 21.7599 22.88Z" fill="#64748B"/>
				<path d="M10.1333 10.9333C10.5752 10.9333 10.9334 10.5751 10.9334 10.1333C10.9333 9.69141 10.5752 9.33325 10.1333 9.33325C9.69156 9.33325 9.33337 9.69144 9.33337 10.1333C9.33337 10.5751 9.69156 10.9333 10.1333 10.9333Z" fill="#64748B"/>
				<path d="M0.799984 1.6C1.24182 1.6 1.6 1.24183 1.6 0.800008C1.59998 0.358165 1.24181 0 0.799968 0C0.358179 0 0 0.358181 0 0.799992C0 1.24183 0.358179 1.6 0.799984 1.6Z" fill="#64748B"/>
			</g>
			<defs>
				<clipPath id="clip0_118_264">
					<rect width="32" height="32" fill="white"/>
				</clipPath>
			</defs>
		</svg>
	</div>
</template>

<script>
export default {
  name: 'Logo',
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  max-width: 100%;
  &--in-sidebar & {
    &__text {
      opacity: 0;
      transition: opacity 0.2s linear;
    }
  }

  &__icon {
    margin-right: 7px;
  }
}
</style>
